<template>
  <div>
    <div class="has-margin-bottom-40 has-margin-top-50 has-border-bottom" v-if="data.additional_handling_information">
      <h2
        class="is-size-5 has-text-weight-bold is-uppercase has-letter-spacing-3 is-black"
      >
        additional information and Documentation
      </h2>
    </div>

    <div class="columns is-multiline">
      <!-- Additional Shipping Information -->
      <div class="column is-12" v-if="data.additional_handling_information">
        <b-field label="Additional Shipping Information ">
          <b-input
            :type="'textarea'"
            v-model="data.additional_handling_information"
            readonly
          ></b-input>
        </b-field>
      </div>

      <!-- Port of Call -->
      <div class="column is-6" v-if="data.port_of_call">
        <b-field label="Port of Call">
          <b-input v-model="data.port_of_call" readonly></b-input>
        </b-field>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ShipperDetail",
  components: {},
  props: {
    data: Object
  },
  data() {
    return {};
  }
};
</script>
